import { CanActivateFn } from '@angular/router';
import { environment } from '../../../environments/environment.dev';

export const developerGuard: CanActivateFn = () => {
  return environment.devMode;
};
